// src/services/gasTariffService.ts
import { apiClient } from './apiConfig';
import { TariffData, TariffRecord } from '../types';

export const listTariffs = async (): Promise<TariffRecord[]> => {
  const response = await apiClient.get<TariffRecord[]>('/gas-tariff-rates');
  return response.data;
};

export const getTariff = async (id: string): Promise<TariffRecord> => {
  const response = await apiClient.get<TariffRecord>(`/gas-tariff-rates/${id}`);
  return response.data;
};

export const createTariff = async (data: TariffData): Promise<void> => {
  await apiClient.put('/gas-tariff-rates', data);
};

export const updateTariff = async (id: string, data: Partial<TariffData>): Promise<void> => {
  await apiClient.put(`/gas-tariff-rates/${id}`, data);
};

export const deleteTariff = async (id: string): Promise<void> => {
  await apiClient.delete(`/gas-tariff-rates/${id}`);
};
